import { render, staticRenderFns } from "./industryDynamicsDetail.vue?vue&type=template&id=5b32cf16&"
import script from "./industryDynamicsDetail.vue?vue&type=script&lang=js&"
export * from "./industryDynamicsDetail.vue?vue&type=script&lang=js&"
import style0 from "./industryDynamicsDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports